module.exports = __webpack_public_path__ + "static/media/bruce3.f47e0d73.mp3";